import './design/global.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { createQueryClient, signInPagePath } from './api';
import { installBrowserErrorHandlers, reportBrowserFailure } from './telemetry';
import { createAppRouter } from './app/router';

installBrowserErrorHandlers();

const PUBLIC_PATHS = /^\/(?:sign-in|welcome|no-access)(?:\/|$)/;

const queryClient = createQueryClient({
  // The session ended while the person was working: back to sign-in, then to the same page.
  onNotSignedIn: () => {
    const { pathname, search } = window.location;
    if (PUBLIC_PATHS.test(pathname)) return;
    void router.navigate(signInPagePath(`${pathname}${search}`), { replace: true });
  },
});

const router = createAppRouter(queryClient);

const root = document.getElementById('root');
if (!root) throw new Error('The page has no #root element.');

createRoot(root, {
  onCaughtError: (error) => {
    reportBrowserFailure(error, 'react_error');
  },
  onUncaughtError: (error) => {
    reportBrowserFailure(error, 'react_error');
  },
  onRecoverableError: (error) => {
    reportBrowserFailure(error, 'react_error');
  },
}).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
